import React, { FC, ReactNode } from "react";
import { StyledSubMenu } from "./styles";

interface SubMenuProps {
  title: string;
  icon: ReactNode;
  open: boolean;
  toggleSubMenu: () => void;
  children: ReactNode;
  selected: string;
  setSelected: (title: string) => void;
  isCollapsed: boolean;
}

export const SubMenuComponent: FC<SubMenuProps> = ({
  title,
  icon,
  open,
  toggleSubMenu,
  children,
  selected,
  setSelected,
  isCollapsed,
}) => {
  const isChildSelected: boolean = React.Children.toArray(children).some(
    (child: any) => child.props.title === selected
  );

  const handleClick = () => {
    toggleSubMenu();
    setSelected(title);
  };

  return (
    <StyledSubMenu
      label={title}
      icon={icon}
      open={open}
      onClick={handleClick}
      active={isChildSelected}
      $isCollapsed={isCollapsed}
    >
      {children}
    </StyledSubMenu>
  );
};
